import { BehaviorSubject } from 'rxjs';

const scoreChallengeRulesModal$ = new BehaviorSubject(false);

const displayScoreChallengeRulesModal = (isShow: boolean) => {
	scoreChallengeRulesModal$.next(isShow);
}

export const scoreChallengeModalService = {
	scoreChallengeRulesModal$: scoreChallengeRulesModal$.asObservable(),
	displayScoreChallengeRulesModal
};